import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDebounced } from '@helpers/useDebounced';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useAuth } from '@hooks/useAuth';
import { apiClient } from '@api/client';

const ApprovalFeatureAnnouncementModal = React.lazy(
  () => import('./ApprovalFeatureAnnouncementModal')
);

const METADATA_KEY = 'approval-v2-announcement';

export default function ApprovalFeatureAnnouncementModalContainer() {
  const { user, updateUserProfile } = useAuth(true);
  const { tourData, showProcess } = useOnboardingProcess();
  const [searchParams] = useSearchParams();
  const userEmail = user?.email || '';
  const announcementSeen =
    !!user.metadata[METADATA_KEY] ||
    userEmail.endsWith('@asu.edu') ||
    userEmail.endsWith('@nbcc.ca');

  const hasActiveTour =
    !!searchParams.get('startTour') || !!tourData?.type || !!showProcess;
  const isOpen = !announcementSeen && !hasActiveTour;
  const debouncedIsOpen = useDebounced(isOpen, 4000, false);
  const visibleDebounced = useDebounced(debouncedIsOpen, 300, false);
  const visible = debouncedIsOpen || visibleDebounced;

  const onClose = () => {
    updateUserProfile({ metadata: { [METADATA_KEY]: true } });
    apiClient.profile.profileControllerUpdateProfileMetadata({
      metadata: { [METADATA_KEY]: true }
    });
  };

  if (!visible) return null;

  return (
    <Suspense fallback={null}>
      <ApprovalFeatureAnnouncementModal open={isOpen} onClose={onClose} />
    </Suspense>
  );
}
